import React, { useContext, useCallback } from "react";
import OnlineDetectorContext from "module/onlineDetector/OnlineDetectorContext";
import { toastSuccess } from "layout/toast/helper";
import t from "module/translations";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { selectSystem, selectUser } from "module/auth/redux/authSlice";
import ToggleContext from "module/toggle/context/ToggleContext";
import unblock from "api/block/unblock";
import { EntityIdentifier, EntityType } from "module/entity/types";
import { removeFromMyEntities } from "module/staff/redux/staffDataSlice";
import DeleteButton from "component/button/DeleteButton";
import ElementWithConfirmation from "component/elementWithConfirmation/ElementWithConfirmation";
import TrainingCustomContext from "module/trainingCustom/context/TrainingCustomContext";
import { TrainingCustomInterface } from "module/trainingCustom/types";

const TrainingCustomDeleteButtonContainer: React.FC = () => {
  const { isOnline } = useContext(OnlineDetectorContext);
  const { entity } = useContext(TrainingCustomContext);

  const dispatch = useAppDispatch();
  const staffId = useAppSelector(selectUser).id;
  const systemShortName = useAppSelector(selectSystem).shortName;
  const { unselectOne } = useContext(ToggleContext);

  const trainingCustom = entity as TrainingCustomInterface;
  const canDelete = isOnline;

  const remove = useCallback(async () => {
    const entityIdentifier: EntityIdentifier = {
      id: trainingCustom.id,
      type: EntityType.trainingCustom,
    };
    // TODO: error handling
    await unblock([entityIdentifier]);
    unselectOne(entityIdentifier);
    dispatch(
      removeFromMyEntities({
        entityIdentifiers: [entityIdentifier],
        staffId,
        systemShortName,
      })
    );
    toastSuccess(t.competencyManagement.trainingCustom.deleteSuccessText);
  }, [dispatch, staffId, systemShortName, trainingCustom.id, unselectOne]);

  if (!canDelete) {
    return null;
  }

  const confirmationDialogTitle = t.deleteTitle;

  return (
    <ElementWithConfirmation
      {...{ confirmationDialogTitle, asyncAction: remove }}
    >
      {(props: { onClick: () => void }) => (
        <DeleteButton {...{ onClick: props.onClick }} />
      )}
    </ElementWithConfirmation>
  );
};

export default React.memo(TrainingCustomDeleteButtonContainer);
